
/**
 * 系统管理
 */
export const loginUrl = '/admin/login'; //登录
export const signOut = '/admin/signOut'; //退出
export const getCaptcha = '/captcha/get'; //获取登录页校验码


//用户权限
export const userListAll = '/admin/pageList'; //用户列表
export const addOrUpdateUser = '/admin/addOrUpdate';  //添加OR编辑用户
export const updateSysModel = '/admin/updateAdminMenu'; //目录权限
export const updatePermission = '/admin/updatePermission'; //目录权限
export const updateAdminState = '/admin/updateAdminState'; //启用或者停用用户

//后台目录
// export const menuListAll = '/systemModel/listAll';
export const addOrUpdateMenuList = '/sys/addOrUpdateMenu';
export const delMenuList = '/sys/delMenu';
export const menuList = '/sys/listMenu';
export const pdateMenuPageDesc = '/sys/updateMenuPageDesc';


//用户日志
export const getUserLogPageList = '/userLog/pageList';
export const addUserLog = '/userLog/add';


/**
 * 公共模块
 */
export const getSysPositionList = '/sys/listPosition';
export const listOnlinePaymentType = '/sys/listOnlinePaymentType';
export const listProjectServiceType = '/project/listProjectServiceType';//项目服务类型
export const getRecordShops = '/shop/recordShops';//记录所生成的门店


/**
 * 门店管理
 */
export const getShopPageList = '/shop/pageList';
export const addOrUpdateShop = '/shop/addOrUpdate';
export const updateShopState = '/shop/updateState';
export const getAllShopList = '/shop/listAll';

//门店价格管理
export const getShopDiscountPageList = '/shop/pageShopDiscountList';
export const updateShopDiscount = '/shop/updateShopDiscount';
export const getShopProjectList = '/project/listShopProject';

//会员价格
export const getShopProjectPricePageList = '/project/pageShopProjectPriceList';
export const updateShopProjectPrice = '/project/updateShopProjectPrice';
export const resetShopProjectPrice = '/project/resetShopProjectPrice';


//项目管理
export const getProjectPageList = '/project/pageList';
export const addOrUpdateProject = '/project/addOrUpdate';
export const updateProjectState = '/project/updateState';
export const listProject = '/project/listProject';

//门店项目价格管理
export const getShopProjectPageList = '/project/pageShopProjectList';
export const addOrUpdateShopProject = '/project/addOrUpdateShopProject';
export const updateShopProjectState = '/project/updateShopProjectState';
export const copyShopProject = '/shop/copyShopProject';
export const shopProjectListAll = '/project/shopProjectListAll';



/**
 * 宠物类别管理
 */
export const getPetPageList = '/pet/pagePetBreedList';
export const addOrUpdatePetBreed = '/pet/addOrUpdatePetBreed';
// export const getCategoryList = '/pet/getCategoryList';
export const delPetBreed = '/pet/delPetBreed';
export const updatePetBreedColor = '/pet/updatePetBreedColor';
export const delPetBreedColor = '/pet/delPetBreedColor';
export const getBreedList = '/pet/getBreedList';
export const addOrUpdatePet = '/pet/addOrUpdatePet';
export const getPet = '/pet/getPet';
export const updatePetDel = '/pet/updateDel';
// export const getAllCategoryAndBreedList = '/pet/getAllCategoryAndBreedList';
export const getAllPetBreedList = '/pet/listAllPetBreed';
export const getPetWeightPageList = '/pet/pageWeightList';
export const updateWeightRemark = '/pet/updateWeightRemark';


//宠物管理
// export const getPetCustomerPageList = '/pet/pageCustomerList';
export const getPetCustomerPageList = '/pet/pageList';
export const getPetProjectOnePageList = '/project/pagePetProjectOneList';
export const statPetProjectOneNum = '/project/statPetProjectOneNum';
export const updateProjectOneRemark = '/project/updateProjectOneRemark';

/**
 * 客户管理
 */
export const getUserCustomerPageList = '/user/pageCustomerList';
export const addOrUpdateCustomer = '/user/addOrUpdate';
export const getUserRemarkPageList = '/user/pageUserRemarkList';
// export const addUserRemark = '/user/addUserRemark';
export const addUserRemark = '/user/addOrUpdateUserRemark';
export const getUserInfo = '/user/getUserInfo';
export const listShopUser = '/user/listShopUser';
export const uploadUserExcel = '/user/uploadUserExcel';
export const uploadPetExcel = '/user/uploadPetExcel';
export const uploadChargeExcel = '/user/uploadChargeExcel';

export const pageUserConsumeList = '/preBook/pageUserConsumeList';
export const getConsumeInfo = '/preBook/getConsumeInfo';

/**
 * 会员管理
 */
export const getMemberPageList = '/user/pageMemberList';
export const getWalletPageList = '/wallet/pageList';
export const payUserWallet = '/wallet/payUserWallet';
export const pagePayList = '/wallet/pagePayList';
export const pageDeductionList = '/wallet/pageDeductionList';
export const getWalletDetailPageList = '/wallet/pageDetailList';
//充值付款截图
export const addWalletDetailImg = '/wallet/addDetailImg';
export const delWalletDetailImg = '/wallet/delDetailImg';


//全局系统参数
export const getSysGlobalParam = '/sys/getGlobalParam';

//消费项目
// export const getOperateAdminsList = '/admin/operateAdmins';
export const getOperateAdminsList = '/admin/listAdminOperates';
// export const getProjectTypeAndPrice = '/project/getProjectTypeAndPrice';
export const getProjectTypeAndPrice = '/project/listShopProject';
export const addOrUpdateProjectAll = '/project/addOrUpdateProjectAll';
export const getProjectAll = '/project/getProjectAll';
export const getProjectAllPageList = '/project/pageProjectAllList';

//支付记录
export const getPaymentDetailPageList = '/payment/pageDetailList';
export const addOrUpdatePaymentDetail = '/payment/addOrUpdateDetail';


/**
 * 预约管理
 */
export const getMonthPreBooksList = '/preBook/getMonthPreBooks';
export const getPreBook = '/preBook/getPreBook'; //获取单个预约单信息
export const cancelPreBook = '/preBook/cancelPreBook'; //取消预约
export const addOrUpdatePreBook = '/preBook/addOrUpdatePreBook'; //新增或者修改预约单
// export const getPreBooksByPhoneOrPetName = '/preBook/getPreBooksByPhoneOrPetName'; //按手机号或者宠物名称查询
// export const getMonthPreBooksExcel = '/preBook/getMonthPreBooksExcel'; //获取某月表格形式或者手机号，宠物名的预约单
export const getMonthPreBooksExcel = '/preBook/pageList'; //获取某月表格形式或者手机号，宠物名的预约单

//提成记录
export const getStatPageList = '/stat/statPage';
export const pageStaffProjectStatList = '/stat/pageStaffProjectStatList';

//角色权限
export const getSysRolePageList = '/sys/pageListSysRole';
export const delSysRole = '/sys/delSysRole';
export const addOrUpdateRoleMenu = '/sys/addOrUpdateRoleMenu';
export const listSysRoleSelect = '/sys/listSysRoleSelect';
export const listFilterSysRole = '/sys/listFilterSysRole';
export const listAdminNameSysRole = '/sys/listAdminNameSysRole';

//获取单天预约单
export const getDayInfo = '/preBook/getDayInfo';

/**
 * 统计管理
 */
//支付统计
export const getPaymentStatPageList = '/payment/pageStatList';
export const getPageStatSummary = '/payment/pageStatSummary';
export const updateMeituanStat = '/payment/updateManualMoney';
export const updateRemarkStat = '/payment/updateRemarkStat';
export const getDetailShopPageList = '/payment/pageDetailShopList';

//消费统计
export const getConsumeStatPageList = '/consumeStat/pageList';
export const getConsumeStatSummary = '/consumeStat/pageSummary';
export const updateConsumeRemark = '/consumeStat/updateRemark';
export const getConsumeDetailShopPageList = '/consumeStat/pageDetailShopList';
export const getConsumeProjectShopPageList = '/consumeStat/pageProjectShopList';

//提成统计
export const getBonusStatPageList = '/bonusStat/pageList';
export const getBonusStatSummary = '/bonusStat/pageSummary';
export const getDetailShopAdminList = '/bonusStat/pageDetailShopAdminList';
export const getUserPayShopAdminList = '/bonusStat/pageUserPayShopAdminList';
export const listShopStaff = '/admin/listShopStaff'; //获取门店员工列表

//复购数统计页面
export const getStatShopRepurchaseList = '/stat/listShopRepurchase';
export const exportShopRepurchaseExcel = '/stat/exportShopRepurchaseExcel';

//充值统计
export const getShopWalletStatList = '/stat/listShopWalletStat';

//提成设置
export const getShopBonusPageList = '/shop/pageShopBonusList';
export const updateShopBonus = '/shop/updateShopBonus';
export const getShopBonusHistoryPageList = '/shop/pageShopBonusHistoryList';
export const pageStaffPayStatList = '/stat/pageStaffPayStatList';

//上传客户图片
export const uploadUserImg = '/user/uploadUserImg';
export const updateUserImgDel = '/user/updateUserImgDel';

//客户日志
export const pageUserLogList = '/user/pageUserLogList';
export const addUserLogList = '/user/addUserLog';

//供应商管理
export const getSupplierPageList = '/supplier/pageList';
export const addOrUpdateSupplier = '/supplier/addOrUpdate';
export const updateSupplierState = '/supplier/updateState';
export const listAllSupplier = '/supplier/listAll';

//品牌管理
export const getBrandPageList = '/brand/pageList';
export const addOrUpdateBrand = '/brand/addOrUpdate';
export const updateBrandState = '/brand/updateState';
export const listAllBrand = '/brand/listAll';

//商品管理
export const getCommodityPageList = '/commodity/pageList';
export const addOrUpdateCommodity = '/commodity/addOrUpdate';
export const updateCommodityState = '/commodity/updateState';
export const uploadCommodityImg = '/commodity/uploadImg';
export const delCommodityImg = '/commodity/updateImgDel';
export const listAllCommodityImg = '/commodity/listImg';
export const uploadCommodityImgCover = '/commodity/updateImgCover';
export const listMeasureUnit = '/commodity/listMeasureUnit';
export const listForPurchase = '/commodity/listForPurchase';//商品列表-添加采购商品页面

//商品分类管理
export const addOrUpdateCommodityType = '/commodity/addOrUpdateType';
export const updateCommodityTypeDel = '/commodity/updateTypeDel';
export const listAllCommodityType = '/commodity/listAllType';

//采购商品
export const getPurchaseCommodityPageList = '/stock/pagePurchaseCommodityList';
export const addOrUpdatePurchaseCommodity = '/stock/addOrUpdatePurchaseCommodity';
export const updatePurchaseCommodityDel = '/stock/updatePurchaseCommodityDel';
export const listPlanPurchaseCommodity = '/stock/listPlanPurchaseCommodity';

//采购单
export const getPurchasePageList = '/stock/pagePurchaseList';
export const addOrUpdatePurchase = '/stock/addOrUpdatePurchase';
export const updatePurchaseDel = '/stock/updatePurchaseDel';
export const updateStockImgDel = '/stock/updateStockImgDel';

//出入库管理
export const getStockPageList = '/stock/pageList';
export const updateStockRemark = '/stock/updateRemark';
export const listStockCommodity = '/stock/listCommodity';
export const updatePurchaseState = '/stock/updatePurchaseState';

//门店商品库存
export const getShopCommodityPageList = '/stock/pageShopCommodityList';
export const getShopCommodityDetailList = '/stock/pageShopCommodityDetailList';
export const updateShopCommodity = '/stock/updateShopCommodity';
export const addSysShopCommodity = '/stock/addSysShopCommodity';
export const updateShopCommodityRemark = '/stock/updateShopCommodityRemark';
export const pageShopCommodityDetailSummary = '/stock/pageShopCommodityDetailSummary';

//门店商品库存
export const getStockTakePageList = '/stockTake/pageList';
export const listStockTakeCommodity = '/stockTake/listCommodity';
export const updateCommodityBreakage = '/stockTake/updateCommodityBreakage';
export const updateCommodityTakeNum = '/stockTake/updateCommodityTakeNum';
export const uploadStockTakeCommodityImg = '/stockTake/uploadCommodityImg';
export const updateStockTakeCommodityImgDel = '/stockTake/updateCommodityImgDel';
export const pageCommodityRemarkList = '/stockTake/pageCommodityRemarkList';
export const addCommodityRemark = '/stockTake/addCommodityRemark';
export const submitAuditStockTake = '/stockTake/submitAudit';
export const stockTakeCommodityPageList = '/stockTake/pageCommodityList';
export const updateStockTakeCommodityState = '/stockTake/updateCommodityState';
export const listCommodityImg = '/stockTake/listCommodityImg';

//解锁密码
export const unlockOrLockMenu = '/sys/unlockOrLockMenu';

//门店的商品列表
export const getShopCommodityList = '/shop/listCommodity';

//客户回访
export const getVisitPageList = '/visit/pageList';
export const getVisitSummaryPageList = '/visit/pageSummary';
export const updateVisitState = '/visit/updateState';
export const updateVisitRecheckState = '/visit/updateRecheckState';
export const uploadVisitImg = '/visit/uploadImg';
export const uploadVisitImgDel = '/visit/updateImgDel';
export const listVisitImg = '/visit/listImg';
export const getUserVisitPageList = '/visit/pageUserList';
export const getVisitStatStateNum = '/visit/statStateNum';

//上传Excel（文本替换）
export const uploadTextExcel = '/admin/uploadExcel';

//评价短信
export const getEvaluationPageList = '/evaluationSms/pageList';
export const getEvaluationPageSummary = '/evaluationSms/pageSummary';
export const updateEvaluationState = '/evaluationSms/updateState';
export const getSmsOff = '/evaluationSms/getSmsOff';
export const updateSmsOff = '/evaluationSms/updateSmsOff';
export const updateEvaluationRemark = '/evaluationSms/updateRemark';

//疫苗已到的数量
export const getExemptionNum = '/user/getExemptionNum';
// export const getExemptionAllNum = '/user/getExemptionAllNum';
export const getExemptionAllNum = '/pet/statStateNum';

//系统菜单标记
export const getSysListMenuTag = '/sys/listMenuTag';

//更新消费备注
export const updatePreBookConsumeRemark = '/preBook/updateConsumeRemark';

//发送邀请评价短信
export const sendInviteSms = '/evaluationSms/sendInviteSms';

//更新通知短信号码
export const updateNotifyPhone = '/evaluationSms/updateNotifyPhone';

//预约管理列表导出
export const exportPreBookExcel = '/preBook/exportExcel';


//获取总部微信配置
export const getSysWechat = '/sys/getSysWechat';
export const updateSysWechat = '/sys/updateSysWechat';

//小程序banner管理
export const getBannerPageList = '/banner/pageList';
export const addOrUpdateBanner = '/banner/addOrUpdate';
export const updateBannerState = '/banner/updateState';

//解绑微信小程序
export const unbindApplet = '/user/unbindApplet';

//添加或编辑宠物洗澡图片
export const addPreBookPetImg = '/preBook/addPetImg';
export const listPreBookPetImg = '/preBook/getPetImgInfo';
export const delPreBookPetImg = '/preBook/delPetImg';
export const sendPreBookPetImg = '/preBook/sendPetImg';

//更新电话回访状态
export const updatePreBookVisitState = '/preBook/updateVisitState';

//赠送项目明细页面
export const getProjectGivePageList = '/project/pageProjectGiveList';

//获取充值记录信息
export const getWalletPayInfo = '/wallet/getPayInfo';

//卫生打卡

//门店配置
export const getShopHygienePageList = '/hygiene/pageShopHygieneList';
export const updateShopHygiene = '/hygiene/updateShopHygiene';
export const updateShopHygieneState = '/hygiene/updateShopHygieneState';

//打卡标准
export const getStandardPageList = '/hygiene/pageStandardList';
export const addOrUpdateStandard = '/hygiene/addOrUpdateStandard';
export const updateStandardState = '/hygiene/updateStandardState';
export const delStandard = '/hygiene/delStandard';
export const addOrUpdateStandardImg = '/hygiene/addOrUpdateStandardImg';
export const delStandardImg = '/hygiene/delStandardImg';
export const reuseStandard = '/hygiene/reuseStandard';
export const listShopStandard = '/hygiene/listShopStandard';
export const listStandardImg = '/hygiene/listStandardImg';

//打卡管理
export const getHygienePageList = '/hygiene/pageList';
export const getHygienePageSummary = '/hygiene/pageSummary';
export const getHygieneDetailPageList = '/hygiene/pageDetailList';
export const updateHygieneDetailResult = '/hygiene/updateDetailResult';
export const hygieneStatStateNum = '/hygiene/statStateNum';


//门店营业时间
export const addOrUpdateBusinessHours = '/shop/addOrUpdateBusinessHours';
export const delBusinessHours = '/shop/delBusinessHours';


//医疗金
export const getMedicalBenefitPageList = '/medicalBenefit/pageDetailList';
export const listMedicalBenefitType = '/sys/listMedicalBenefitType';
export const updateMedicalDetailRemark = '/medicalBenefit/updateDetailRemark';
export const addOrUpdateMedicalDetail = '/medicalBenefit/addOrUpdateDetail';
export const delMedicalDetailImg = '/medicalBenefit/delDetailImg';

//门店基本配置
export const getShopConfigPageList = '/shop/pageShopConfigList';
export const updateShopConfig = '/shop/updateShopConfig';
export const uploadShopImg = '/shop/uploadShopImg';
export const updateMedicalState = '/shop/updateMedicalState';

//系统参数
export const getSysParamPageList = '/sys/pageSysParamList';
export const addOrUpdateSysParam = '/sys/addOrUpdateSysParam';

//邀请奖励
export const getInvitePrizePageList = '/invite/pagePrizeList';
export const addOrUpdateInvitePrize = '/invite/addOrUpdatePrize';
export const updateInvitePrizeState = '/invite/updatePrizeState';

//邀请用户
export const getInvitePageList = '/invite/pageStatList';
export const getInviteUserPageList = '/invite/pageUserList';

//好评返现
export const getCashbackPageList = '/inviteEvaluation/pageList';
export const updateCashbackState = '/inviteEvaluation/updateState';
export const updateCashbackRemark = '/inviteEvaluation/updateRemark';
export const updateCashbackRemitImg = '/inviteEvaluation/updateRemitImg';
export const addCashbackInvite = '/inviteEvaluation/addInvite';
export const getCashbackStatStateNum = '/inviteEvaluation/statStateNum';

//保障案例
export const getMedicalCasePageList = '/case/pageList';
export const addOrUpdateMedicalCase = '/case/addOrUpdate';
export const udpateMedicalCaseState = '/case/udpateState';
export const addMedicalCaseImg = '/case/addImg';
export const delMedicalCaseImg = '/case/delImg';

//保障单页面
export const getSecurityPageList = '/medicalSecurity/pageList';
export const getSecurityDetailPageList = '/medicalSecurity/pageDetailList';
export const getSecurityInvitePageList = '/medicalSecurity/pageInviteList';
//更新保障记录备注
export const updateSecurityDetailRemark = '/medicalSecurity/updateDetailRemark';
export const getGiveUserInfo = '/medicalSecurity/getGiveUserInfo';
export const medicalSecurityGiveNum = '/medicalSecurity/giveNum';

//渠道页面
export const getChannelPageList = '/channel/pageList';
export const addOrUpdateChannel = '/channel/addOrUpdate';
export const updateChannelState = '/channel/updateState';
export const getChannelUserPageList = '/channel/pageUserList';
export const getAllChannelList = '/channel/listAll';
